import React, { useState } from 'react';
import { loginTenantByCccd } from '../../services/tenantQrAuthApi';

type Props = {
  onSuccess: () => Promise<void> | void;
  onCancel: () => void;
};

const MobileTenantQrLogin: React.FC<Props> = ({ onSuccess, onCancel }) => {
  const [cccd, setCccd] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const digits = cccd.replace(/\D/g, '');
  const canSubmit = digits.length === 9 || digits.length === 12;

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    if (busy || !canSubmit) return;
    setBusy(true);
    setError('');
    try {
      await loginTenantByCccd(digits);
      await onSuccess();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Không đăng nhập được bằng số căn cước này');
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={handleLogin} className="min-h-0 flex-1 space-y-4 overflow-y-auto">
      <div>
        <label htmlFor="tenant-cccd" className="mb-1 block text-sm font-medium text-[#2B2520]">
          Số căn cước công dân trên hợp đồng
        </label>
        <input
          id="tenant-cccd"
          type="text"
          inputMode="numeric"
          autoComplete="off"
          required
          value={cccd}
          onChange={(event) => setCccd(event.target.value.replace(/\D/g, '').slice(0, 12))}
          className="w-full rounded-xl border border-[#D8B86A]/40 bg-white px-4 py-3 text-base text-black outline-none focus:ring-2 focus:ring-[#C4A35A]"
          placeholder="12 số CCCD hoặc 9 số CMND"
        />
      </div>
      {error && <p className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>}
      <button
        type="submit"
        disabled={busy || !canSubmit}
        className="w-full rounded-xl bg-[#C4A35A] py-3 text-sm font-semibold text-white disabled:opacity-60"
      >
        {busy ? 'Đang đăng nhập...' : 'Đăng nhập'}
      </button>
      <button type="button" onClick={onCancel} className="w-full py-2 text-sm text-[#2B2520]/60">
        Hủy
      </button>
    </form>
  );
};

export default MobileTenantQrLogin;
